import { render, staticRenderFns } from "./IbxAppNotification.vue?vue&type=template&id=166fc50a&scoped=true"
import script from "./IbxAppNotification.vue?vue&type=script&lang=js"
export * from "./IbxAppNotification.vue?vue&type=script&lang=js"
import style0 from "./IbxAppNotification.vue?vue&type=style&index=0&id=166fc50a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "166fc50a",
  null
  
)

export default component.exports